export default {
  STATUS_DRAFT: "Draft",
  STATUS_SUBMITTED: "Submitted",
  STATUS_ACCEPTED: "Accepted",
  STATUS_REJECTED: "Rejected",
  STATUS_CANCELED: "Canceled",
  DELETE_ESTABLISHMENT_TRANSFER: "Delete the establishment transfer",
  ADD_ITEMS_FIRST: "Add at least one transfer item before submitting.",
  ACCEPT: "Accept",
  REJECT: "Reject",
  SUBMITTED_BY: "Submitted by",
  SUBMITTED_AT: "Submitted at",
  ACCEPTED_BY: "Accepted by",
  ACCEPTED_AT: "Accepted at",
  TRANSFER_DATE: "Transfer date",
  CHANGE_ACCEPTED_DATE: "Change the invoicing date",
  CHANGE_ACCEPTED_DATE_HELP:
    "This date decides which weekly report week the transfer is counted in.",
  ACCEPTED_DATE: "Accounting date",
  ACCEPTED_DATE_UPDATED: "Invoicing date updated",
  CANCEL_ACCEPTED_TRANSFER: "Cancel this accepted transfer?",
  CANCEL_ACCEPTED_TRANSFER_HELP:
    "The transfer will be removed from the weekly report of both establishments, including a report already validated.",
};
